import { render, staticRenderFns } from "./BiddingItems.vue?vue&type=template&id=7cb1ba60&scoped=true&"
import script from "./BiddingItems.vue?vue&type=script&lang=js&"
export * from "./BiddingItems.vue?vue&type=script&lang=js&"
import style0 from "./BiddingItems.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BiddingItems.vue?vue&type=style&index=1&id=7cb1ba60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb1ba60",
  null
  
)

export default component.exports